import { PaymentSkeletonWrapper } from '@/pages/AddCard/components/AddPaymentMethodForm/AddPaymentMethodForm.styled';

export function PaymentSkelleton() {
  return (
    <PaymentSkeletonWrapper>
      <div className="skeleton-title" />
      <div className="skeleton-text" />
      <div className="skeleton-form" />
    </PaymentSkeletonWrapper>
  );
}
